/* 
.el {
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20%);
}
.el.show_on_scroll {
    transition: all 0.8s ease;
    opacity: 1;
    transform: translateY(0);
}

{{ 'scrollAnimationUtils.js' | asset_url | script_tag }}
*/

const animOnScroll = (items, options = { threshold: 0.3 }) => {
  if (items.length === 0) return;

  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show_on_scroll");
      } else {
        entry.target.classList.remove("show_on_scroll");
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  items.forEach((item) => {
    observer.observe(item);
  });
};

const setTransitionDelay = (
  elementsToDelay,
  minScreenWidthForDelay,
  delayFactor = 0.2
) => {
  const { innerWidth } = window;

  elementsToDelay.forEach((element, index) => {
    let delay = 0;

    if (minScreenWidthForDelay) {
      delay = innerWidth >= minScreenWidthForDelay ? index * delayFactor : 0;
    } else {
      delay = index * delayFactor;
    }

    element.style.transitionDelay = `${delay}s`;
  });
};
